import { esusApi } from "@/services/api";
import { DentalAttendance } from "@/@types/esus/DentalAttendance";

export type DetailedCitizenAttendancesIndicatorB2Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
	citizenId: number;
};

export class DetailedCitizenAttendancesIndicatorB2 {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";
	dentalAttendances?: DentalAttendance[];
}

export async function getDetailedCitizenAttendancesIndicatorB2({
	uf,
	ibgeCode,
	...params
}: DetailedCitizenAttendancesIndicatorB2Params) {
	const response = await esusApi.get<DetailedCitizenAttendancesIndicatorB2>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b2/detailed-citizen-attendances`,
		params
	);
	return response.data ?? new DetailedCitizenAttendancesIndicatorB2();
}
